import { browserHistory } from 'react-router'
import * as CONFIG from '../config'

export const HOME_PAGE = CONFIG.BASE_ROUTE
export const EMPTY_PAGE = `${CONFIG.BASE_ROUTE}empty`
export const LOGIN_PAGE = `${CONFIG.BASE_ROUTE}login`
export const AUDIT_PAGE = `${CONFIG.BASE_ROUTE}audit`
export const MANAGERS_PAGE = `${CONFIG.BASE_ROUTE}managers`
export const EMPLOYEES_PAGE = `${CONFIG.BASE_ROUTE}employees`
export const TAGS_PAGE = `${CONFIG.BASE_ROUTE}tags`
export const STATISTICS_PAGE = `${CONFIG.BASE_ROUTE}statistics`
export const CURRENT_CAMPAIGN_PAGE = `${CONFIG.BASE_ROUTE}current-campaign`
export const EMAILS_HISTORY_PAGE = `${CONFIG.BASE_ROUTE}emails-history`
export const NEW_CAMPAIGN_PAGE = `${CONFIG.BASE_ROUTE}new-campaign`
export const UNASSIGNED_EMAILS_PAGE = `${CONFIG.BASE_ROUTE}unassigned-emails`
export const CURRENT_EXTRA_CAMPAIGN_PAGE = `${CONFIG.BASE_ROUTE}current-extra-campaign`
export const NEW_EXTRA_CAMPAIGN_PAGE = `${CONFIG.BASE_ROUTE}new-extra-campaign`
export const EMAILS_HISTORY_EXTRA_PAGE = `${CONFIG.BASE_ROUTE}emails-history-extra`
export const UNASSIGNED_EMAILS_EXTRA_PAGE = `${CONFIG.BASE_ROUTE}unassigned-emails-extra`
export const MANAGE_USERS_PAGE = `${CONFIG.BASE_ROUTE}manage-users`
export const MANAGE_REPORTS_PAGE = `${CONFIG.BASE_ROUTE}manage-reports`
export const VIEW_REPORTS_PAGE = `${CONFIG.BASE_ROUTE}view-reports`
export const VIEW_BULK_REPORTS_PAGE = `${CONFIG.BASE_ROUTE}view-bulk-reports`
export const EMAIL_TEMPLATES_PAGE = `${CONFIG.BASE_ROUTE}email-templates`
export const EMAIL_RULES_PAGE = `${CONFIG.BASE_ROUTE}email-rules`
export const SCHEDULER_PAGE = `${CONFIG.BASE_ROUTE}scheduler`
export const MANAGE_CAMPAIGNS_PAGE = `${CONFIG.BASE_ROUTE}manage-campaigns`
export const DASHBOARD_PAGE = `${CONFIG.BASE_ROUTE}dashboard`

export function goToPage (page, search, state) {
  let pageObj = {}
  pageObj.pathname = page
  if (search) {
    pageObj.search = search // '?the=query',
  }
  if (state) {
    pageObj.state = state // { some: 'state' }
  }
  browserHistory.push(pageObj)
}

/* if (!user && (path !== Navigator.HOME_PAGE) && (path !== Navigator.LOGIN_PAGE)) {
    browserHistory.push(Navigator.LOGIN_PAGE)
  } */

export function reloadToPage (page) {
  location.pathname = page
}

export function getCurrentPage () {
  return location.pathname
}



// WEBPACK FOOTER //
// ./src/modules/Navigator.js